// src/services/couponService.js
import axios from "axios";
import API_BASE_URL from "../config/apiConfig";

const API_BASE = `${API_BASE_URL}/api/coupons`;

// services/couponService.js
export const suggestCoupon = async (cartValue) => {
  const res = await axios.get(
    `${API_BASE_URL}/api/coupons/suggest?cartValue=${cartValue}`
  );
  return res.data; // returns an array of coupons
};

export const applyCoupon = async (code, cartValue) => {
  const res = await axios.get(`${API_BASE}/apply`, {
    params: { code, cartValue },
  });
  return res.data;
};

// Admin - create coupon (optional, used for testing or CMS)
export const createCoupon = async (couponData) => {
  const res = await axios.post(`${API_BASE}/admin/create`, couponData);
  return res.data;
};
